const UPLOAD_STARTED = "uploadStarted";
const UPLOAD_FINISHED = "uploadFinished";
const UPLOAD_ERRORED = "uploadErrored";
const PROCESSING_STARTED = "processingStarted";
const PROCESSING_FINISHED = "processingFinished";
const PHOTO_UPLOADED = "photoUploaded";
const UPLOADED_ARTWORK = "uploadedArtwork";

export const EVENTS = {
  UPLOAD_STARTED,
  UPLOAD_FINISHED,
  UPLOAD_ERRORED,
  PROCESSING_STARTED,
  PROCESSING_FINISHED,
  PHOTO_UPLOADED,
  UPLOADED_ARTWORK
};

export function getDataLayer() {
  window.dataLayer = window.dataLayer || [];
  return window.dataLayer;
}

export function dataLayerHasEmployeeFlag() {
  const dataLayer = getDataLayer();
  return Boolean(dataLayer?.find(data => data.employee));
}

function addEventToDataLayer(values) {
  const dataLayer = getDataLayer();
  if (Object.keys(values).length > 0 && !dataLayerHasEmployeeFlag()) {
    return dataLayer.push(values);
  } else {
    // eslint-disable-next-line
    console.log("employee flagged action: ", values);
  }
}

export function add(values = {}) {
  if (Array.isArray(values)) {
    values.forEach(item => addEventToDataLayer(item));
  } else {
    addEventToDataLayer(values);
  }
}

export function addInternalEvent(values = {}) {
  const dataLayer = getDataLayer();

  if (Object.keys(values).length > 0) {
    return dataLayer.push(values);
  }
}
